export default "__VITE_ASSET__DeNU6XYa__"